import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ElPagination } from 'element-plus';

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'Pagination',
  props: /*@__PURE__*/_mergeModels({
    totalPosts: {}
  }, {
    "current-size": {},
    "current-sizeModifiers": {},
    "page-size": {},
    "page-sizeModifiers": {},
  }),
  emits: ["update:current-size", "update:page-size"],
  setup(__props: any) {



// Pagination data as defineModel
const currentPage = _useModel<number>(__props, 'current-size');
const pageSize = _useModel<number>(__props, 'page-size');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElPagination), {
    class: "pagination",
    "current-page": currentPage.value,
    "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
    "page-size": pageSize.value,
    "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((pageSize).value = $event)),
    "page-sizes": [12, 20, 35, 50],
    total: _ctx.totalPosts,
    layout: "total, sizes, prev, pager, next, jumper",
    "popper-class": "select-options"
  }, null, 8, ["current-page", "page-size", "total"]))
}
}

})